import { createRouter, createWebHashHistory } from 'vue-router'
import layout from '@/layout'

import Home from '@/views/home'
import store from '@/store'

/**
 * 私有路由表
 */
export function importAllAsyncRoutes() {
  const webpackContext = require.context('./modules', true, /\.js$/)

  // 查找到的第一个模块路径
  const asyncRoutes = webpackContext.keys().map((item) => {
    const route = webpackContext(item)

    return route.default
  })

  console.log('asyncRoutes', asyncRoutes)
  return asyncRoutes
}

/**
 * 公开路由表
 */
export const publicRoutes = [
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/',
    component: layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: Home,
        meta: {
          title: '首页',
          icon: 'home'
        }
      },
      {
        path: '/password',
        name: 'password',
        meta: {
          title: '修改密码'
        },
        component: () => import('@/views/password/index.vue')
      },
      {
        path: '/hisBind',
        name: 'hisBind',
        meta: {
          title: 'his绑定'
        },
        component: () => import('@/views/hisBind/index.vue')
      },
      {
        path: '/appLinkClinic',
        name: 'appLinkClinic',
        meta: {
          title: 'App Link门诊'
        },
        component: () => import('@/views/applink-clinic/index.vue')
      },
      {
        path: '/appLinkLog',
        name: 'appLinkLog',
        meta: {
          title: 'App Link日志'
        },
        component: () => import('@/views/applink-log/index.vue')
      },
      {
        path: '/404',
        name: '404',
        component: () => import(/* webpackChunkName: "error-page" */ '@/views/error-page/404'),
        meta: {
          title: '404'
        }
      },
      {
        path: '/401',
        name: '401',
        component: () => import(/* webpackChunkName: "error-page" */ '@/views/error-page/401'),
        meta: {
          title: '401'
        }
      }
    ]
  }
]

export const notFoundRoute = {
  path: '/:pathMatch(.*)*',
  redirect: '/404'
}

const router = createRouter({
  history: process.env.NODE_ENV === 'production' ? createWebHashHistory() : createWebHashHistory(),
  routes: [...publicRoutes]
})

export function resetRouter() {
  if (store.getters.userInfo && store.getters.userInfo.menuPermission && store.getters.userInfo.menuPermission.menus) {
    const menus = store.getters.userInfo.menuPermission.menus.map((item) => item.name)
    menus.forEach((menu) => {
      if (router.hasRoute(menu)) {
        router.removeRoute(menu)
      }
    })
  }
}

export default router
